// Write your code here
import './index.css'

const DestinationItem = props => {
  const {items} = props
  const {name, imgUrl} = items
  return (
    <li className="bg">
      <img src={imgUrl} alt={name} className="img" />
      <p className="heading">{name}</p>
    </li>
  )
}
export default DestinationItem
